import { nothing, html } from "lit";
import { SignalWatcher } from "@lit-labs/preact-signals";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import "../IconButton/index.js";
import "../Button/index.js";
import "../Badge/index.js";
import "../../atom/Row/index.js";
import "../../atom/Icon/index.js";
import "../../atom/Text/index.js";
import "../../atom/Column/index.js";
import "../Link/index.js";
import { isMobile } from "../../../responsive/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfBreadcrumbs = class extends SignalWatcher(BaseComponent) {
  constructor() {
    super(...arguments);
    this.dsf_crumbs = [];
    this.dsf_back_button = false;
    this.onNavigate = (route) => {
      this.emit({ name: "navigate", payload: route });
    };
    this.onSpace = (e, route) => {
      if (e.code === "Space") {
        e.preventDefault();
        this.emit({ name: "navigate", payload: route });
      }
    };
  }
  renderBackButton() {
    if (!this.dsf_back_button) return nothing;
    return html`
      <dsf-button
        class="dsf-pr-s"
        dsf_level="secondary"
        dsf_size="small"
        dsf_square
        dsf_icon_left="ArrowLeft"
        data-back-button
        @click=${() => this.onNavigate("back")}
      ></dsf-button>
    `;
  }
  renderBadge() {
    if (!this.dsf_badge) return nothing;
    return html`<dsf-badge>${this.dsf_badge}</dsf-badge>`;
  }
  renderLink(crumb, arrow = false, badge = false, text) {
    return html`
      <dsf-link
        data-link
        dsf_no_underline
        @click=${() => this.onNavigate(crumb.route)}
        @keydown=${(e) => this.onSpace(e, crumb.route)}
      >
        <dsf-text .dsf_level=${text.level} dsf_color_intensity=${text.intensity}
          >${crumb.name}</dsf-text
        >
        ${badge ? this.renderBadge() : nothing}
      </dsf-link>
      ${arrow ? html`<dsf-icon class="h-12 w-12" dsf_name="ChevronRight"></dsf-icon>` : nothing}
    `;
  }
  renderDesktop() {
    return html`
      ${this.renderBackButton()}
      <dsf-row dsf_gap="xs">
        ${this.dsf_crumbs.reduce((acc, crumb, idx, arr) => {
      const renderBadge = idx === 0;
      const renderArrow = idx !== arr.length - 1;
      const link = this.renderLink(crumb, renderArrow, renderBadge, {
        level: "s-medium",
        intensity: idx === 0 ? 700 : 300
      });
      acc.push(link);
      return acc;
    }, [])}
      </dsf-row>
    `;
  }
  renderMobile() {
    const [title, ...rest] = this.dsf_crumbs;
    return html`
      <dsf-col>
        <dsf-row dsf_gap="xs">
          ${title && this.renderLink(title, false, true, {
      level: "s-medium",
      intensity: 700
    })}
        </dsf-row>

        <dsf-row dsf_gap="xs">
          ${rest.map(
      (crumb, idx) => this.renderLink(crumb, idx !== rest.length - 1, false, {
        level: "xs",
        intensity: 300
      })
    )}
        </dsf-row>
      </dsf-col>
    `;
  }
  render() {
    if (isMobile()) {
      return this.renderMobile();
    }
    return this.renderDesktop();
  }
};
__decorateClass([
  prop({ type: Object })
], DsfBreadcrumbs.prototype, "dsf_crumbs", 2);
__decorateClass([
  prop({ type: String })
], DsfBreadcrumbs.prototype, "dsf_badge", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfBreadcrumbs.prototype, "dsf_back_button", 2);
DsfBreadcrumbs = __decorateClass([
  defineElement("dsf-breadcrumbs")
], DsfBreadcrumbs);
export {
  DsfBreadcrumbs
};
